import type { EDealType } from 'shared/types/features';

export const withCianMedium = (url: string, dealType: EDealType): string => {
  const parsedUrl = new URL(url);
  parsedUrl.searchParams.set('cian_medium', dealType);

  return parsedUrl.toString();
};
